import axios from '@/api/axios'

const getCompetitionFinance = (id) => {
  return axios.get(`/competition/finances/${id}`)
}

const addCompetitionFinance = (competition) => {
  return axios.post(`/competition/finances`, competition)
}

const updateCompetitionFinance = (competition) => {
  return axios.put(`/competition/finances/${competition.id}`, competition)
}

export default {
  getCompetitionFinance,
  addCompetitionFinance,
  updateCompetitionFinance,
}
